import moment from 'moment'

export function formatUserDate(date?: Date) {
  if (!date) return null

  return moment(date).format('DD MMMM YYYY HH:mm')
}

export function formatUserDay(date?: Date) {
  if (!date) return null
  return moment(date).format('DD.MM.YYYY')
}

export function formatUserHours(date?: Date) {
  if (!date) return null
  return moment(date).format('HH:mm')
}
